import { useBackend } from "../../services";

export const useGetShelfSegment = () => {
  const { get } = useBackend();
  const getShelfSegment = (parameters: IGetShelfSegmentParameters) =>
    get("shelfSegments", parameters);
  return { getShelfSegment };
};

export interface IGetShelfSegmentParameters {
  uuid: string;
}
